import styled from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0px;
  z-index: -1;
`;

export default Wrapper(template)
